module.exports = __webpack_public_path__ + "static/media/topUpIcon.3630b0dc.svg";